/**
 * iMikel-style sub-tab strip used inside the main "Veranstaltungen",
 * "Abrechnung" and "Übersicht" tabs of the Unterrichtsverwaltung page.
 *
 * Visually mirrors iMikel: small, dense, white/light-grey strip with the
 * active sub-tab in solid Anthrazit.
 */
import React from 'react';

export default function SubTabs({ value, onChange, items }) {
  return (
    <div className="flex items-center gap-1 border-b border-slate-200 bg-slate-50 px-2 py-1 overflow-x-auto" data-testid="imikel-subtabs">
      {items.map((it) => {
        const active = it.value === value;
        const disabled = it.disabled;
        return (
          <button
            key={it.value}
            type="button"
            disabled={disabled}
            onClick={() => !disabled && onChange(it.value)}
            data-testid={`subtab-${it.value}`}
            className={`text-[11px] px-2.5 py-1 rounded transition-colors whitespace-nowrap ${
              active
                ? 'bg-brand-red text-white font-semibold'
                : disabled
                  ? 'text-slate-300 cursor-not-allowed'
                  : 'text-slate-700 hover:bg-brand-red/10'
            }`}
            title={disabled ? 'Folgt in einem späteren Schritt' : it.label}
          >
            {it.label}
          </button>
        );
      })}
    </div>
  );
}
